<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-input
            size="small"
            @keyup.enter.native="handleFilter"
            style="width: 200px; margin-right: 10px"
            class="filter-item"
            placeholder="姓名"
            v-model="listQuery.name"
          >
          </el-input>
          <el-button
            size="small"
            class="filter-item"
            type="primary"
            icon="search"
            @click="handleFilter"
            >搜索</el-button
          >
          <el-button
            size="small"
            class="filter-item"
            style="margin-left: 10px"
            @click="handleCreate"
            type="primary"
            icon="edit"
            >添加</el-button
          >
        </div>
      </div>
    </template>

    <el-table
      :key="tableKey"
      :data="list"
      v-loading.body="listLoading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column align="center" label="id" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="代理人姓名">
        <template slot-scope="scope">
          <span>{{ scope.row.agentName }}</span>
        </template>
      </el-table-column>
      <el-table-column width="50px" align="center" label="性别">
        <template slot-scope="scope">
          <span>{{ scope.row.sex }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="律所名称">
        <template slot-scope="scope">
          <span>{{ scope.row.lawfirmName }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="电话">
        <template slot-scope="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="代理人类型">
        <template slot-scope="scope">
          <span>{{ scope.row.agentType }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="身份证">
        <template slot-scope="scope">
          <span>{{ scope.row.idCard }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="律师执业证号">
        <template slot-scope="scope">
          <span>{{ scope.row.lawyerLicenseNo }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="邮箱">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="送达地址">
        <template slot-scope="scope">
          <span>{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="修改人">
        <template slot-scope="scope">
          <span>{{ scope.row.operator }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="修改时间">
        <template slot-scope="scope">
          <span>{{ scope.row.editTime }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            v-permission:function="['czAgentManager_btn_edit']"
            size="small"
            type="success"
            @click="handleUpdate(scope.row)"
            >编辑
          </el-button>
          <el-button
            v-permission:function="['czAgentManager_btn_del']"
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="代理人姓名" prop="agentName">
          <el-input
            v-model="form.agentName"
            placeholder="请输入代理人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="代理人性别" prop="sex">
          <el-radio-group
            v-model="form.sex"
            style="width: 18rem"
            placeholder="请选择代理人性别"
          >
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="律所名称" prop="lawfirmName">
          <el-input
            v-model="form.lawfirmName"
            placeholder="请输入律所名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="代理人类型" prop="agentType">
          <el-input
            v-model="form.agentType"
            placeholder="请输入代理人类型"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard">
          <el-input v-model="form.idCard" placeholder="请输入身份证"></el-input>
        </el-form-item>
        <el-form-item label="执业证号" prop="lawyerLicenseNo">
          <el-input
            v-model="form.lawyerLicenseNo"
            placeholder="请输入律师执业证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" placeholder="地址"></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="wechat">
          <el-input v-model="form.wechat" placeholder="微信号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button
          v-if="dialogStatus == 'create'"
          size="small"
          type="primary"
          @click="create('form')"
          >确 定</el-button
        >
        <el-button v-else type="primary" size="small" @click="update('form')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </d2-container>
</template>
<style scoped>
</style>
<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj,
} from "@/api/czManager/czAgent/index";
import { mapGetters } from "vuex";
export default {
  name: "czAgent",
  data() {
    return {
      form: {
        sex: "男",
        agentName: undefined,
        lawfirmName: undefined,
        phone: undefined,
        agentType: undefined,
        idCard: undefined,
        lawyerLicenseNo: undefined,
        email: undefined,
        address: undefined,
        operator: undefined,
        editTime: undefined,
      },
      rules: {
        sex: [
          {
            required: true,
            message: "请选择代理人性别",
            trigger: "change",
          },
        ],
        agentName: [
          {
            required: true,
            message: "请输入代理人姓名",
            trigger: "blur",
          },
        ],
        lawfirmName: [
          {
            required: true,
            message: "请输入律所名称",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },
        ],
        agentType: [
          {
            required: true,
            message: "请输入代理人类型",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入身份证",
            trigger: "blur",
          },
        ],
        lawyerLicenseNo: [
          {
            required: true,
            message: "请输入代理人律师执业证号",
            trigger: "blur",
          },
        ],
        founder: [
          {
            required: true,
            message: "请输入创建人",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        operator: [
          {
            required: true,
            message: "请输入修改人",
            trigger: "blur",
          },
        ],
        editTime: [
          {
            required: true,
            message: "请输入修改时间",
            trigger: "blur",
          },
        ],
      },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters(["elements"]),
  },
  methods: {
    getList() {
      this.listLoading = true;
      page(this.listQuery).then((response) => {
        this.list = response.rows;
        this.total = response.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      getObj(row.id).then((response) => {
        this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = "update";
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delObj(row.id).then(() => {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          addObj(this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    resetTemp() {
      this.form = {
        username: undefined,
        name: undefined,
        sex: "男",
        password: undefined,
        description: undefined,
      };
    },
  },
};
</script>
